import script from "./DetallePersona.vue?vue&type=script&setup=true&lang=js"
export * from "./DetallePersona.vue?vue&type=script&setup=true&lang=js"

import "./DetallePersona.vue?vue&type=style&index=0&id=192ec34b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-192ec34b"]])

export default __exports__